module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputFieldValue),
      expression: "inputFieldValue"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    staticStyle: {
      "padding": "2px 0",
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": _vm.uniqueId,
      "placeholder": _vm.cplaceholder
    },
    domProps: {
      "value": (_vm.inputFieldValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.internalValue = _vm.filteredResults[0]
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputFieldValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "autocompletions-box card",
    class: {
      'expanded': this.autocompleting
    }
  }, [_vm._l((_vm.filteredResults), function(result, i) {
    return _c('a', {
      staticClass: "completion",
      class: {
        highlighted: i == 0
      },
      on: {
        "click": function($event) {
          _vm.internalValue = result
        }
      }
    }, [_c('c-avatar', {
      attrs: {
        "family": result,
        "link": false
      }
    }), _vm._v(" " + _vm._s(result.name) + "\n\t\t\t")], 1)
  }), _vm._v(" "), (_vm.cache.requestRunning) ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t(...)\n\t\t\t")]) : (_vm.cache.results.length === 0 && _vm.autocompleteStub !== '') ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t(няма резултати)\n\t\t\t")]) : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62324fba!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/autocomplete/f-family.vue
// module id = 659
// module chunks = 1